﻿<div [class.hidden]="!enabled" class="rdo-loader">
    <img src="/assets/images/loader-sm.gif" width="20" height="20" />
</div>
